import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Locale } from 'vant'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import zhHK from 'vant/lib/locale/lang/zh-HK' //vant 自带国际化繁体包
import en from 'vant/lib/locale/lang/en-US' // 新增的英文语言包
import zhLocale from './zh_cn' // 本地定义的简体中文
import tcLocale from './zh_tc' // 本地定义的繁体中文
import enLocale from './en_us' // 新增的英文语言包
import initI18n from '../tools'

Vue.use(VueI18n)
const i18n = initI18n({ zhLocale, tcLocale, enLocale })

// 更新vant组件库本身的语言变化，支持国际化
function vantLocales(lang) {
    if (lang === 'zhCN') {
        Locale.use('zh-CN', zhCN)
    } else if (lang === 'zhTC') {
        Locale.use('zh-HK', zhHK)
    } else if (lang === 'en') {
        Locale.use('en-US', en)
    }
}

export { i18n, vantLocales }